// extracted by mini-css-extract-plugin
export default {"root":"SaasLayout_root__rgVH-"};